import React from "react";

export default function TimelineDivider() {
    return <div className="rounded" style={{width: "8px", height: "50px",marginBottom: "10px", backgroundColor: "#7a7a7a"}}/>;
}